"use client"

import React from "react"
import Swal from "sweetalert2"
import authAxios from "../../services/Token"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { 
  faInfo, 
  faSave, 
  faUser, 
  faFolder, 
  faPrint, 
  faBook, 
  faGraduationCap, 
  faCalendar,
  faFilePdf,
  faFileVideo,
  faFileImage,
  faFile,
  faTasks,
  faChevronDown,
  faChevronUp,
  faQuestionCircle,
  faList,
  faCheckSquare,
  faKeyboard,
  faPaperPlane,
  faDownload,
  faPlay,
  faTimes,
  faCertificate,
  faUsers,
  faEnvelope,
  faIdCard,
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faChartBar
} from "@fortawesome/free-solid-svg-icons"

const fechaactual = new Date().toLocaleString().split(",")
const f = fechaactual[0].split("/")
const hoy = f[2].padStart(2, "0") + "-" + f[1].padStart(2, "0") + "-" + f[0].padStart(2, "0")
const fechaActual2 = new Date()
fechaActual2.setDate(fechaActual2.getDate() - 5)

const f2 = fechaActual2.toLocaleDateString().split("/")
const haceDosDias = f2[2].padStart(2, "0") + "-" + f2[1].padStart(2, "0") + "-" + f2[0].padStart(2, "0")

class Docente extends React.Component {
  constructor(props) {
    super(props)
    this.Enviar = this.Enviar.bind(this)
    this.handleCheckboxChangeFilter = this.handleCheckboxChangeFilter.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
    this.VerContenidoCurso = this.VerContenidoCurso.bind(this)
    this.toggleClase = this.toggleClase.bind(this)
    this.VerEvaluacion = this.VerEvaluacion.bind(this)
    this.cerrarEvaluacion = this.cerrarEvaluacion.bind(this)
    this.handleRespuestaChange = this.handleRespuestaChange.bind(this)
    this.handleRespuestaMultipleChange = this.handleRespuestaMultipleChange.bind(this)
    this.handleRespuestaLibreChange = this.handleRespuestaLibreChange.bind(this)
    this.enviarEvaluacion = this.enviarEvaluacion.bind(this)
    this.abrirVideo = this.abrirVideo.bind(this)
    this.cerrarVideo = this.cerrarVideo.bind(this)
    this.abrirDocumento = this.abrirDocumento.bind(this)
    this.cerrarDocumento = this.cerrarDocumento.bind(this)
    this.descargarCertificado = this.descargarCertificado.bind(this)
    this.cerrarCertificado = this.cerrarCertificado.bind(this)
    this.verEstudiantes = this.verEstudiantes.bind(this)
    this.cerrarEstudiantes = this.cerrarEstudiantes.bind(this)
    this.descargarComoPDF = this.descargarComoPDF.bind(this)
    this.imprimirCertificado = this.imprimirCertificado.bind(this)
    this.abrirModalCrearClase = this.abrirModalCrearClase.bind(this)
    this.cerrarModalCrearClase = this.cerrarModalCrearClase.bind(this)
    this.crearClase = this.crearClase.bind(this)
    this.borrarClase = this.borrarClase.bind(this)
    this.abrirModalGestionarContenido = this.abrirModalGestionarContenido.bind(this)
    this.cerrarModalGestionarContenido = this.cerrarModalGestionarContenido.bind(this)
    this.crearContenido = this.crearContenido.bind(this)
    this.editarContenido = this.editarContenido.bind(this)
    this.borrarContenido = this.borrarContenido.bind(this)
    this.abrirModalEditarContenido = this.abrirModalEditarContenido.bind(this)
    this.verEvaluacionesEstudiante = this.verEvaluacionesEstudiante.bind(this)
    this.cerrarEvaluacionesEstudiante = this.cerrarEvaluacionesEstudiante.bind(this)
  }
  
  state = {
    datosCargados: false,
    sinRegistrar: true,
    registrado: false,
    ListaTabla: [],
    ListaVehiculos: [],
    ListaConductor: [],
    selectedItems: [],
    selectAll: false,
    Hoy: hoy,
    haceDosDias: haceDosDias,
    cursoSeleccionado: null,
    clasesCurso: [],
    clasesAbiertas: {},
    evaluacionAbierta: false,
    preguntasEvaluacion: [],
    respuestasUsuario: {},
    evaluacionActual: null,
    videoAbierto: false,
    videoUrl: "",
    documentoAbierto: false,
    documentoUrl: "",
    documentoNombre: "",
    certificadoAbierto: false,
    certificadoData: null,
    estudiantesAbierto: false,
    listaEstudiantes: [],
    cursoActual: null,
    modalCrearClase: false,
    modalGestionarContenido: false,
    modalEditarContenido: false,
    nuevaClase: {
      titulo: "",
      curso: ""
    },
    nuevoContenido: {
      clase: "",
      descripcion: "",
      descripcion_larga: "",
      url_video: "",
      archivo: null
    },
    contenidoEditando: null,
    listaContenidos: [],
    evaluacionesEstudianteAbierto: false,
    evaluacionesEstudianteData: [],
    estudianteSeleccionado: null
  }

  handleSelectAll(event) {
    const { ListaTabla, sinRegistrar, registrado } = this.state
    const isChecked = event.target.checked

    const filteredList = ListaTabla.filter((item) => {
      if (sinRegistrar && registrado) {
        return true
      } else if (sinRegistrar) {
        return item.estado !== "Registrado"
      } else if (registrado) {
        return item.estado === "Registrado"
      } else {
        return false
      }
    })

    if (isChecked) {
      this.setState({ selectedItems: filteredList, selectAll: true })
    } else {
      this.setState({ selectedItems: [], selectAll: false })
    }
  }

  handleCheckboxChangeFilter(event) {
    const target = event.target
    const name = target.name
    const checked = target.checked

    this.setState({
      [name]: checked,
    })
  }

  getFilteredList() {
    const { sinRegistrar, registrado, ListaTabla } = this.state
    return ListaTabla.filter((item) => {
      if (sinRegistrar && registrado) {
        return true
      } else if (sinRegistrar) {
        return item.estado !== "Registrado"
      } else if (registrado) {
        return item.estado === "Registrado"
      } else {
        return false
      }
    })
  }

  async VerContenidoCurso(cursoId) {
    try {
      Swal.showLoading()
      var estudiante_id = localStorage.getItem("cliente_id")
      const response = await authAxios.get(`cursos/clases/${cursoId}/${estudiante_id}`)
      Swal.close()
      
      this.setState({ 
        cursoSeleccionado: cursoId,
        clasesCurso: response.data 
      })
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudo cargar el contenido del curso", "error")
    }
  }

  async VerEvaluacion(evaluacionId, claseTitulo, claseId) {
    try {
      Swal.showLoading()
      const response = await authAxios.get(`cursos/evaluacion/${evaluacionId}`)
      Swal.close()
      
      // Inicializar respuestas vacías
      const respuestasIniciales = {}
      response.data.forEach(pregunta => {
        if (pregunta.preguntas.tipo_pregunta === "SELECCION MULTIPLE") {
          respuestasIniciales[pregunta.preguntas.idp] = []
        } else {
          respuestasIniciales[pregunta.preguntas.idp] = ""
        }
      })
      
      this.setState({ 
        evaluacionAbierta: true,
        preguntasEvaluacion: response.data,
        respuestasUsuario: respuestasIniciales,
        evaluacionActual: { 
          id: evaluacionId, 
          titulo: claseTitulo,
          clase_id: claseId 
        }
      })
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudo cargar la evaluación", "error")
    }
  }

  cerrarEvaluacion() {
    this.setState({ 
      evaluacionAbierta: false,
      preguntasEvaluacion: [],
      respuestasUsuario: {},
      evaluacionActual: null
    })
  }

  // Nueva función para ver evaluaciones del estudiante
  async verEvaluacionesEstudiante(estudiante, curso) {
    try {
      Swal.showLoading()
      const response = await authAxios.get(`docente/RespuestaEstudiante/${estudiante.ide}/${curso.id}`)
      Swal.close()
      
      this.setState({
        evaluacionesEstudianteAbierto: true,
        evaluacionesEstudianteData: response.data,
        estudianteSeleccionado: estudiante,
        cursoActual: curso
      })
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudieron cargar las evaluaciones del estudiante", "error")
    }
  }

  cerrarEvaluacionesEstudiante() {
    this.setState({
      evaluacionesEstudianteAbierto: false,
      evaluacionesEstudianteData: [],
      estudianteSeleccionado: null,
      cursoActual: null
    })
  }

  abrirVideo(urlVideo) {
    this.setState({
      videoAbierto: true,
      videoUrl: urlVideo
    })
  }

  cerrarVideo() {
    this.setState({
      videoAbierto: false,
      videoUrl: ""
    })
  }

  abrirDocumento(urlDocumento, nombreDocumento) {
    this.setState({
      documentoAbierto: true,
      documentoUrl: `http://127.0.0.1:8000/storage/${urlDocumento}`,
      documentoNombre: nombreDocumento
    })
  }

  cerrarDocumento() {
    this.setState({
      documentoAbierto: false,
      documentoUrl: "",
      documentoNombre: ""
    })
  }

  async descargarCertificado(curso) {
    try {
        const estudiante_id = localStorage.getItem("cliente_id");
        
        Swal.showLoading();
        
        // Obtener datos del certificado
        const response = await authAxios.post('cursos/generar-certificado', {
            curso_id: curso.id,
            estudiante_id: estudiante_id
        });
        
        Swal.close();
        
        if (response.data.success) {
            // Mostrar el certificado en un modal con opción de imprimir/descargar
            this.setState({
                certificadoAbierto: true,
                certificadoData: response.data
            });
        } else {
            Swal.fire("Error", response.data.message, "error");
        }

    } catch (error) {
        Swal.close();
        Swal.fire("Error", "No se pudo generar el certificado", "error");
    }
  }

  descargarComoPDF() {
    const { certificadoData } = this.state;
    
    // Crear una ventana nueva con el contenido del certificado
    const ventana = window.open('', '_blank');
    ventana.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Certificado - ${certificadoData.curso_nombre}</title>
            <style>
                body { 
                    font-family: Arial, sans-serif; 
                    margin: 0; 
                    padding: 20px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }
                .certificate-container {
                    width: 29.7cm;
                    height: 21cm;
                    margin: 0 auto;
                    background: white;
                    border: 20px solid #f8f9fa;
                    position: relative;
                    box-shadow: 0 0 20px rgba(0,0,0,0.1);
                }
                .certificate-header {
                    text-align: center;
                    padding: 40px 0 20px;
                    border-bottom: 3px solid #007bff;
                }
                .certificate-body {
                    padding: 40px;
                    text-align: center;
                }
                .certificate-title {
                    font-size: 36px;
                    color: #007bff;
                    margin-bottom: 30px;
                    font-weight: bold;
                }
                .student-name {
                    font-size: 28px;
                    color: #333;
                    font-weight: bold;
                    margin: 20px 0;
                    padding: 10px;
                    border-bottom: 2px solid #007bff;
                    display: inline-block;
                }
                .course-name {
                    font-size: 24px;
                    color: #007bff;
                    font-weight: bold;
                    margin: 20px 0;
                }
                .certificate-footer {
                    position: absolute;
                    bottom: 40px;
                    left: 0;
                    right: 0;
                    padding: 20px 40px;
                    border-top: 2px solid #dee2e6;
                }
                .signature-area {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 60px;
                }
                .signature {
                    text-align: center;
                    width: 45%;
                }
                .signature-line {
                    border-top: 1px solid #333;
                    width: 200px;
                    margin: 0 auto;
                    padding-top: 10px;
                }
                .watermark {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) rotate(-45deg);
                    font-size: 120px;
                    color: rgba(0,123,255,0.1);
                    font-weight: bold;
                    z-index: -1;
                }
                @media print {
                    body { 
                        background: white !important; 
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    .certificate-container {
                        box-shadow: none !important;
                        border: none !important;
                        width: 100% !important;
                        height: 100% !important;
                    }
                    .no-print { display: none !important; }
                }
            </style>
        </head>
        <body>
            <div class="certificate-container">
                <div class="watermark">CERTIFICADO</div>
                
                <div class="certificate-header">
                    <h1>${certificadoData.empresa_nombre}</h1>
                    <p>NIT: ${certificadoData.empresa_nit}</p>
                    ${certificadoData.empresa_direccion ? `<p>${certificadoData.empresa_direccion}</p>` : ''}
                </div>
                
                <div class="certificate-body">
                    <div class="certificate-title">CERTIFICADO DE FINALIZACIÓN</div>
                    
                    <p>La empresa <strong>${certificadoData.empresa_nombre}</strong> certifica que:</p>
                    
                    <div class="student-name">${certificadoData.estudiante_nombre_completo}</div>
                    
                    <p>Ha completado satisfactoriamente el curso:</p>
                    
                    <div class="course-name">${certificadoData.curso_nombre}</div>
                    
                    <p>
                        Con un promedio de aprobación de <strong>${certificadoData.promedio_notas}%</strong><br>
                        Código del curso: <strong>${certificadoData.curso_codigo}</strong><br>
                        Materias completadas: ${certificadoData.materias_completadas} de ${certificadoData.total_materias}<br>
                        Período: ${new Date(certificadoData.fecha_inicio).toLocaleDateString()} - ${new Date(certificadoData.fecha_final).toLocaleDateString()}
                    </p>
                    
                    <p>
                        Se otorga el presente certificado en reconocimiento al esfuerzo y dedicación 
                        demostrados durante el proceso de capacitación.
                    </p>
                </div>
                
                <div class="certificate-footer">
                    <p class="text-center">Fecha de emisión: ${certificadoData.fecha_emision}</p>
                    <p class="text-center">Código del certificado: <strong>${certificadoData.codigo_certificado}</strong></p>
                    
                    <div class="signature-area">
                        <div class="signature">
                            <div class="signature-line"></div>
                            <p>Firma del Director</p>
                        </div>
                        <div class="signature">
                            <div class="signature-line"></div>
                            <p>Firma del Coordinador</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="no-print" style="text-align: center; margin-top: 20px;">
                <button onclick="window.print()" style="padding: 10px 20px; font-size: 16px; margin: 5px;">
                    🖨️ Imprimir Certificado
                </button>
                <button onclick="window.close()" style="padding: 10px 20px; font-size: 16px; margin: 5px;">
                    ❌ Cerrar
                </button>
            </div>
        </body>
        </html>
    `);
    ventana.document.close();
  }

  imprimirCertificado() {
    window.print();
  }

  cerrarCertificado() {
    this.setState({
      certificadoAbierto: false,
      certificadoData: null
    });
  }

  async verEstudiantes(curso) {
    try {
      Swal.showLoading();
      const response = await authAxios.get(`docente/estudiantes/${curso.id}`);
      Swal.close();
      
      this.setState({
        estudiantesAbierto: true,
        listaEstudiantes: response.data,
        cursoActual: curso
      });
    } catch (error) {
      Swal.close();
      Swal.fire("Error", "No se pudieron cargar los estudiantes", "error");
    }
  }

  cerrarEstudiantes() {
    this.setState({
      estudiantesAbierto: false,
      listaEstudiantes: [],
      cursoActual: null
    });
  }

  toggleClase(claseId) {
    this.setState(prevState => ({
      clasesAbiertas: {
        ...prevState.clasesAbiertas,
        [claseId]: !prevState.clasesAbiertas[claseId]
      }
    }))
  }

  // Funciones para gestionar clases
  abrirModalCrearClase(curso) {
    this.setState({
      modalCrearClase: true,
      nuevaClase: {
        titulo: "",
        curso: curso.id
      }
    });
  }

  cerrarModalCrearClase() {
    this.setState({
      modalCrearClase: false,
      nuevaClase: {
        titulo: "",
        curso: ""
      }
    });
  }

  async crearClase() {
    const { nuevaClase } = this.state;
    
    if (!nuevaClase.titulo.trim()) {
      Swal.fire("Error", "Por favor ingresa un título para la clase", "error");
      return;
    }

    try {
      Swal.showLoading();
      
      const docente_id = localStorage.getItem("cliente_id");
      const datosClase = {
        ...nuevaClase,
        docente: docente_id
      };

      const response = await authAxios.post("docente/RegistrarClases", datosClase);
      
      Swal.close();
      Swal.fire("¡Éxito!", "Clase creada correctamente", "success");
      
      this.cerrarModalCrearClase();
      // Recargar el contenido del curso
      if (this.state.cursoSeleccionado) {
        this.VerContenidoCurso(this.state.cursoSeleccionado);
      }
      
    } catch (error) {
      Swal.close();
      Swal.fire("Error", "No se pudo crear la clase", "error");
    }
  }

  async borrarClase(claseId) {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará la clase y todo su contenido",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar"
    });

    if (result.isConfirmed) {
      try {
        Swal.showLoading();
        
        const response = await authAxios.get(`docente/BorrarClases/${claseId}`);
        
        Swal.close();
        Swal.fire("¡Éxito!", "Clase eliminada correctamente", "success");
        
        // Recargar el contenido del curso
        if (this.state.cursoSeleccionado) {
          this.VerContenidoCurso(this.state.cursoSeleccionado);
        }
        
      } catch (error) {
        Swal.close();
        Swal.fire("Error", "No se pudo eliminar la clase", "error");
      }
    }
  }

  // Funciones para gestionar contenido
  async abrirModalGestionarContenido(clase) {
    try {
      Swal.showLoading();
      
      // Cargar contenidos existentes de la clase
      const response = await authAxios.get(`docente/ContenidoClases/${clase.materia.ccc}`);
      console.log(response.data.data);
      this.setState({
        modalGestionarContenido: true,
        claseSeleccionada: clase,
        listaContenidos: response.data.data,
        nuevoContenido: {
          clase: clase.materia.ccc,
          descripcion: "",
          descripcion_larga: "",
          url_video: "",
          archivo: null
        }
      });
      
      Swal.close();
    } catch (error) {
      Swal.close();
      Swal.fire("Error", "No se pudieron cargar los contenidos", "error");
    }
  }

  cerrarModalGestionarContenido() {
    this.setState({
      modalGestionarContenido: false,
      modalEditarContenido: false,
      claseSeleccionada: null,
      listaContenidos: [],
      nuevoContenido: {
        clase: "",
        descripcion: "",
        descripcion_larga: "",
        url_video: "",
        archivo: null
      },
      contenidoEditando: null
    });
  }

  abrirModalEditarContenido(contenido) {
    this.setState({
      modalEditarContenido: true,
      contenidoEditando: contenido,
      nuevoContenido: {
        clase: contenido.clase,
        descripcion: contenido.descripcion,
        descripcion_larga: contenido.descripcion_larga || "",
        url_video: contenido.url_video || "",
        archivo: null
      }
    });
  }

  handleArchivoChange = (event) => {
    const file = event.target.files[0];
    this.setState(prevState => ({
      nuevoContenido: {
        ...prevState.nuevoContenido,
        archivo: file
      }
    }));
  }

  async crearContenido() {
    const { nuevoContenido, claseSeleccionada } = this.state;
    
    if (!nuevoContenido.descripcion.trim()) {
      Swal.fire("Error", "Por favor ingresa una descripción para el contenido", "error");
      return;
    }

    try {
      Swal.showLoading();
      
      const docente_id = localStorage.getItem("cliente_id");
      const formData = new FormData();
      
      formData.append("clase", nuevoContenido.clase);
      formData.append("descripcion", nuevoContenido.descripcion);
      formData.append("descripcion_larga", nuevoContenido.descripcion_larga);
      formData.append("url_video", nuevoContenido.url_video);
      formData.append("docente", docente_id);
      
      if (nuevoContenido.archivo) {
        formData.append("archivo", nuevoContenido.archivo);
      }

      const response = await authAxios.post("docente/ContenidoClases", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      Swal.close();
      
      if (response.data.success) {
        Swal.fire("¡Éxito!", "Contenido creado correctamente", "success");
        
        // Limpiar formulario y recargar contenidos
        this.setState({
          nuevoContenido: {
            ...this.state.nuevoContenido,
            descripcion: "",
            descripcion_larga: "",
            url_video: "",
            archivo: null
          }
        });
        
        // Recargar lista de contenidos
        this.abrirModalGestionarContenido(claseSeleccionada);
      } else {
        if (response.data.contenido_existente) {
          Swal.fire({
            title: "Contenido duplicado",
            text: response.data.message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ver contenido existente",
            cancelButtonText: "Cerrar"
          }).then((result) => {
            if (result.isConfirmed) {
              // Aquí podrías navegar al contenido existente si es necesario
            }
          });
        } else {
          Swal.fire("Error", response.data.message, "error");
        }
      }
      
    } catch (error) {
      Swal.close();
      if (error.response && error.response.data && error.response.data.contenido_existente) {
        Swal.fire({
          title: "Contenido duplicado",
          text: error.response.data.message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ver contenido existente",
          cancelButtonText: "Cerrar"
        });
      } else {
        Swal.fire("Error", "No se pudo crear el contenido", "error");
      }
    }
  }

  async editarContenido() {
    const { nuevoContenido, contenidoEditando } = this.state;
    
    if (!nuevoContenido.descripcion.trim()) {
      Swal.fire("Error", "Por favor ingresa una descripción para el contenido", "error");
      return;
    }

    try {
      Swal.showLoading();
      
      const docente_id = localStorage.getItem("cliente_id");
      const formData = new FormData();
      
      formData.append("clase", nuevoContenido.clase);
      formData.append("descripcion", nuevoContenido.descripcion);
      formData.append("descripcion_larga", nuevoContenido.descripcion_larga);
      formData.append("url_video", nuevoContenido.url_video);
      formData.append("docente", docente_id);
      
      if (nuevoContenido.archivo) {
        formData.append("archivo", nuevoContenido.archivo);
      }

      const response = await authAxios.post(`docente/EditarContenidoClase/${contenidoEditando.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      Swal.close();
      
      if (response.data.success) {
        Swal.fire("¡Éxito!", "Contenido actualizado correctamente", "success");
        this.cerrarModalGestionarContenido();
        
        // Recargar el contenido del curso
        if (this.state.cursoSeleccionado) {
          this.VerContenidoCurso(this.state.cursoSeleccionado);
        }
      } else {
        Swal.fire("Error", response.data.message, "error");
      }
      
    } catch (error) {
      Swal.close();
      Swal.fire("Error", "No se pudo actualizar el contenido", "error");
    }
  }

  async borrarContenido(contenidoId) {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará el contenido permanentemente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar"
    });

    if (result.isConfirmed) {
      try {
        Swal.showLoading();
        
        const response = await authAxios.get(`docente/BorrarContenido/${contenidoId}`);
        
        Swal.close();
        
        if (response.data.success) {
          Swal.fire("¡Éxito!", "Contenido eliminado correctamente", "success");
          
          // Recargar lista de contenidos
          const { claseSeleccionada } = this.state;
          if (claseSeleccionada) {
            this.abrirModalGestionarContenido(claseSeleccionada);
          }
          
          // Recargar el contenido del curso
          if (this.state.cursoSeleccionado) {
            this.VerContenidoCurso(this.state.cursoSeleccionado);
          }
        } else {
          Swal.fire("Error", response.data.message, "error");
        }
        
      } catch (error) {
        Swal.close();
        Swal.fire("Error", "No se pudo eliminar el contenido", "error");
      }
    }
  }

  getIconoPorTipo(archivo) {
    if (!archivo) return faFile
    
    const extension = archivo.split('.').pop().toLowerCase()
    if (['pdf'].includes(extension)) return faFilePdf
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) return faFileImage
    if (['mp4', 'avi', 'mov', 'wmv'].includes(extension)) return faFileVideo
    return faFile
  }

  getIconoTipoPregunta(tipo) {
    switch(tipo) {
      case "UNICA RESPUESTA":
        return faList
      case "SELECCION MULTIPLE":
        return faCheckSquare
      case "RESPUESTA LIBRE":
        return faKeyboard
      default:
        return faQuestionCircle
    }
  }

  handleRespuestaChange(preguntaId, respuestaId) {
    this.setState(prevState => ({
      respuestasUsuario: {
        ...prevState.respuestasUsuario,
        [preguntaId]: respuestaId
      }
    }))
  }

  handleRespuestaMultipleChange(preguntaId, respuestaId, checked) {
    this.setState(prevState => {
      const respuestasActuales = prevState.respuestasUsuario[preguntaId] || []
      let nuevasRespuestas
      
      if (checked) {
        nuevasRespuestas = [...respuestasActuales, respuestaId]
      } else {
        nuevasRespuestas = respuestasActuales.filter(id => id !== respuestaId)
      }
      
      return {
        respuestasUsuario: {
          ...prevState.respuestasUsuario,
          [preguntaId]: nuevasRespuestas
        }
      }
    })
  }

  handleRespuestaLibreChange(preguntaId, valor) {
    this.setState(prevState => ({
      respuestasUsuario: {
        ...prevState.respuestasUsuario,
        [preguntaId]: valor
      }
    }))
  }

  async enviarEvaluacion() {
    const { respuestasUsuario, evaluacionActual } = this.state
    const estudiante_id = localStorage.getItem("cliente_id")
    
    // Validar que todas las preguntas tengan respuesta
    const preguntasSinResponder = this.state.preguntasEvaluacion.filter(pregunta => {
      const respuesta = respuestasUsuario[pregunta.preguntas.idp]
      if (pregunta.preguntas.tipo_pregunta === "SELECCION MULTIPLE") {
        return !respuesta || respuesta.length === 0
      }
      return !respuesta || respuesta.toString().trim() === ""
    })

    if (preguntasSinResponder.length > 0) {
      Swal.fire("Atención", "Por favor responde todas las preguntas antes de enviar la evaluación.", "warning")
      return
    }

    try {
      Swal.showLoading()
      
      // Preparar datos para enviar
      const datosEvaluacion = {
        evaluacion_id: evaluacionActual.id,
        respuestas: respuestasUsuario,
        fecha_envio: new Date().toISOString(),
        clase: evaluacionActual.clase_id,
        estudiante: estudiante_id
      }

      await authAxios.post("cursos/save-respuesta", datosEvaluacion)
      
      Swal.close()
      Swal.fire("¡Éxito!", "Evaluación enviada correctamente", "success")
      this.cerrarEvaluacion()
      
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudo enviar la evaluación", "error")
    }
  }

  MostrarTabla() {
    Swal.showLoading()
    let bname = document.getElementById("bnombre").value
    let use = localStorage.getItem("cliente_id")
    var dato = { buscar: use, nombre: bname }
    
    authAxios
      .post("docente/cursos", dato)
      .then((datosRespuesta) => {
        Swal.close()
        this.setState({ 
          datosCargados: true, 
          load: "", 
          ListaTabla: datosRespuesta.data,
          cursoSeleccionado: null,
          clasesCurso: []
        })
      })
      .catch(error => {
        Swal.close()
        Swal.fire("Error", "No se pudieron cargar los cursos", "error")
      })
  }

  componentDidMount() {
    this.MostrarTabla(1)
  }

  Enviar() {
    const form = document.getElementById("formulario")
    const formData = new FormData(form)
    Swal.showLoading()
    authAxios
      .post("transporte/guardarservicio", formData)
      .then((datosRespuesta) => {
        Swal.close()
        Swal.fire("Servicio!", datosRespuesta.data.msj.MensajeRespuesta, "success")
        document.getElementById("formulario").reset()
        this.MostrarTabla(1)
      })
      .catch()
  }

  renderPregunta(preguntaData) {
    const { preguntas, respuestas } = preguntaData
    const { respuestasUsuario } = this.state
    const respuestaActual = respuestasUsuario[preguntas.idp]

    return (
      <div key={preguntas.idp} className="card mb-4">
        <div className="card-header bg-light">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon 
              icon={this.getIconoTipoPregunta(preguntas.tipo_pregunta)} 
              className="text-primary me-2"
            />
            <span className="badge bg-primary me-2">
              {preguntas.tipo_pregunta}
            </span>
            <strong>Pregunta {preguntas.idp}</strong>
          </div>
        </div>
        <div className="card-body">
          <h6 className="card-title mb-3">{preguntas.nombre_pregunta}</h6>
          
          {preguntas.tipo_pregunta === "UNICA RESPUESTA" && (
            <div className="list-group">
              {respuestas.map((respuesta) => (
                <label key={respuesta.id} className="list-group-item">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={`pregunta_${preguntas.idp}`}
                      value={respuesta.id}
                      checked={respuestaActual === respuesta.id}
                      onChange={() => this.handleRespuestaChange(preguntas.idp, respuesta.id)}
                    />
                    <span className="form-check-label">
                      {respuesta.descripcion}
                      {respuesta.score > 0 && (
                        <small className="text-muted ms-2">({respuesta.score} puntos)</small>
                      )}
                    </span>
                  </div>
                </label>
              ))}
            </div>
          )}

          {preguntas.tipo_pregunta === "SELECCION MULTIPLE" && (
            <div className="list-group">
              {respuestas.map((respuesta) => (
                <label key={respuesta.id} className="list-group-item">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={respuesta.id}
                      checked={respuestaActual.includes(respuesta.id)}
                      onChange={(e) => this.handleRespuestaMultipleChange(
                        preguntas.idp, 
                        respuesta.id, 
                        e.target.checked
                      )}
                    />
                    <span className="form-check-label">
                      {respuesta.descripcion}
                      {respuesta.score > 0 && (
                        <small className="text-muted ms-2">({respuesta.score} puntos)</small>
                      )}
                    </span>
                  </div>
                </label>
              ))}
            </div>
          )}

          {preguntas.tipo_pregunta === "RESPUESTA LIBRE" && (
            <div>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Escribe tu respuesta aquí..."
                value={respuestaActual || ""}
                onChange={(e) => this.handleRespuestaLibreChange(preguntas.idp, e.target.value)}
              />
              <small className="text-muted">
                Escribe tu respuesta en el espacio proporcionado.
              </small>
            </div>
          )}
        </div>
      </div>
    )
  }

  extraerVideoId(url) {
    if (!url) return ''
    
    // Para YouTube
    const match = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/)
    return match ? match[1] : ''
  }

  // Función para calcular el puntaje total de una evaluación
  calcularPuntajeTotal(evaluacion) {
    return evaluacion.respuestas.reduce((total, respuesta) => {
      return total + (respuesta.puntaje || 0);
    }, 0);
  }

  // Función para calcular el puntaje obtenido en una evaluación
  calcularPuntajeObtenido(evaluacion) {
    return evaluacion.respuestas.reduce((total, respuesta) => {
      return total + (respuesta.score || 0);
    }, 0);
  }

  render() {
    const filteredList = this.getFilteredList()
    const { 
      load, 
      ListaTabla, 
      pagina, 
      ultimo, 
      actual, 
      cursoSeleccionado, 
      clasesCurso,
      clasesAbiertas,
      evaluacionAbierta,
      preguntasEvaluacion,
      evaluacionActual,
      videoAbierto,
      videoUrl,
      documentoAbierto,
      documentoUrl,
      documentoNombre,
      certificadoAbierto,
      certificadoData,
      estudiantesAbierto,
      listaEstudiantes,
      cursoActual,
      modalCrearClase,
      modalGestionarContenido,
      modalEditarContenido,
      nuevaClase,
      nuevoContenido,
      listaContenidos,
      claseSeleccionada,
      contenidoEditando,
      evaluacionesEstudianteAbierto,
      evaluacionesEstudianteData,
      estudianteSeleccionado
    } = this.state

    const videoId = this.extraerVideoId(videoUrl)
    const estudiante_nombre = localStorage.getItem("cliente_nombre") || "Estudiante";

    return (
      <div className="content">
        <div className="container-fluid">
          <br />
          
          {/* Modal de Evaluaciones del Estudiante */}
          {evaluacionesEstudianteAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faChartBar} className="me-2" />
                      Evaluaciones Realizadas - {estudianteSeleccionado?.nombre}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarEvaluacionesEstudiante}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="alert alert-info">
                      <FontAwesomeIcon icon={faInfo} className="me-2" />
                      Detalle de todas las evaluaciones realizadas por el estudiante en el curso: {cursoActual?.descripcion}
                    </div>
                    
                    {evaluacionesEstudianteData.length > 0 ? (
                      <div className="evaluaciones-list">
                        {evaluacionesEstudianteData.map((evaluacion, index) => {
                          const puntajeTotal = this.calcularPuntajeTotal(evaluacion);
                          const puntajeObtenido = this.calcularPuntajeObtenido(evaluacion);
                          const porcentaje = puntajeTotal > 0 ? (puntajeObtenido / puntajeTotal) * 100 : 0;
                          
                          return (
                            <div key={evaluacion.id} className="card mb-4">
                              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-0 text-primary">{evaluacion.titulo}</h6>
                                  <small className="text-muted">
                                    Evaluación: {evaluacion.nombre_evaluacion}
                                  </small>
                                </div>
                                <div className="text-end">
                                  <span className={`badge ${porcentaje >= 70 ? 'bg-success' : 'bg-warning'} me-2`}>
                                    {puntajeObtenido} / {puntajeTotal} puntos
                                  </span>
                                  <span className={`badge ${porcentaje >= 70 ? 'bg-success' : 'bg-warning'}`}>
                                    {porcentaje.toFixed(1)}%
                                  </span>
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="mb-3">
                                  <strong>Curso:</strong> {evaluacion.curso_principal}
                                </div>
                                
                                <h6 className="text-primary mb-3">Respuestas:</h6>
                                <div className="table-responsive">
                                  <table className="table table-bordered table-hover">
                                    <thead className="table-light">
                                      <tr>
                                        <th>#</th>
                                        <th>Pregunta</th>
                                        <th>Respuesta</th>
                                        <th>Puntaje Obtenido</th>
                                        <th>Puntaje Máximo</th>
                                        <th>Fecha</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {evaluacion.respuestas.map((respuesta, idx) => (
                                        <tr key={respuesta.id} className={respuesta.score === respuesta.puntaje ? 'table-success' : respuesta.score > 0 ? 'table-warning' : 'table-danger'}>
                                          <td>{idx + 1}</td>
                                          <td>
                                            <div>
                                              <strong>{respuesta.nombre_pregunta}</strong>
                                              {respuesta.descripcion && (
                                                <div className="text-muted">
                                                  Opciones: {respuesta.descripcion}
                                                </div>
                                              )}
                                            </div>
                                          </td>
                                          <td>
                                            {respuesta.respuesta_texto ? (
                                              <div>
                                                <strong>Respuesta libre:</strong>
                                                <div className="mt-1 p-2 bg-light rounded">
                                                  {respuesta.respuesta_texto}
                                                </div>
                                              </div>
                                            ) : (
                                              <span className="text-muted">Selección múltiple</span>
                                            )}
                                          </td>
                                          <td>
                                            <span className={`badge ${respuesta.score === respuesta.puntaje ? 'bg-success' : respuesta.score > 0 ? 'bg-warning' : 'bg-danger'}`}>
                                              {respuesta.score || 0} pts
                                            </span>
                                          </td>
                                          <td>
                                            <span className="badge bg-secondary">
                                              {respuesta.puntaje || 0} pts
                                            </span>
                                          </td>
                                          <td>
                                            <small className="text-muted">
                                              {new Date(respuesta.fecha_registro).toLocaleDateString()}
                                            </small>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                                
                                <div className="row mt-3">
                                  <div className="col-md-6">
                                    <div className="card bg-light text-secondary">
                                      <div className="card-body text-center">
                                        <h5 className="card-title">Resumen</h5>
                                        <div className="row">
                                          <div className="col-6">
                                            <h3 className={`text-${porcentaje >= 70 ? 'success' : 'warning'}`}>
                                              {porcentaje.toFixed(1)}%
                                            </h3>
                                            <small>Porcentaje</small>
                                          </div>
                                          <div className="col-6">
                                            <h3 className="text-primary">
                                              {puntajeObtenido}/{puntajeTotal}
                                            </h3>
                                            <small>Puntaje</small>
                                          </div>
                                        </div>
                                        <div className="mt-2">
                                          <div className="progress" style={{height: '10px'}}>
                                            <div 
                                              className={`progress-bar ${porcentaje >= 70 ? 'bg-success' : 'bg-warning'}`}
                                              role="progressbar" 
                                              style={{width: `${porcentaje}%`}}
                                              aria-valuenow={porcentaje}
                                              aria-valuemin="0" 
                                              aria-valuemax="100"
                                            ></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="card bg-light  text-secondary">
                                      <div className="card-body">
                                        <h6 className="card-title">Estadísticas</h6>
                                        <div className="small">
                                          <div className="d-flex justify-content-between">
                                            <span>Correctas:</span>
                                            <span className="text-success">
                                              {evaluacion.respuestas.filter(r => r.score === r.puntaje).length}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <span>Parciales:</span>
                                            <span className="text-warning">
                                              {evaluacion.respuestas.filter(r => r.score > 0 && r.score < r.puntaje).length}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <span>Incorrectas:</span>
                                            <span className="text-danger">
                                              {evaluacion.respuestas.filter(r => r.score === 0).length}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <span>Total Preguntas:</span>
                                            <span className="text-primary">
                                              {evaluacion.respuestas.length}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center text-muted py-5">
                        <FontAwesomeIcon icon={faChartBar} size="3x" className="mb-3" />
                        <h5>No hay evaluaciones realizadas por este estudiante</h5>
                        <p>El estudiante no ha completado ninguna evaluación en este curso.</p>
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={this.cerrarEvaluacionesEstudiante}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal Crear Clase */}
          {modalCrearClase && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      Crear Nueva Clase
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarModalCrearClase}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Título de la Clase</label>
                      <input
                        type="text"
                        className="form-control"
                        value={nuevaClase.titulo}
                        onChange={(e) => this.setState({
                          nuevaClase: {...nuevaClase, titulo: e.target.value}
                        })}
                        placeholder="Ingresa el título de la clase"
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={this.cerrarModalCrearClase}
                    >
                      Cancelar
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-primary" 
                      onClick={this.crearClase}
                    >
                      <FontAwesomeIcon icon={faSave} className="me-2" />
                      Crear Clase
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal Gestionar Contenido */}
          {(modalGestionarContenido || modalEditarContenido) && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faBook} className="me-2" />
                      {modalEditarContenido ? 'Editar Contenido' : 'Gestionar Contenido'} - {claseSeleccionada?.materia?.titulo}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarModalGestionarContenido}
                    ></button>
                  </div>
                  <div className="modal-body">
                    
                    {/* Formulario para crear/editar contenido */}
                    <div className="card mb-4">
                      <div className="card-header bg-light">
                        <h6 className="mb-0">
                          {modalEditarContenido ? 'Editar Contenido' : 'Agregar Nuevo Contenido'}
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Descripción *</label>
                              <input
                                type="text"
                                className="form-control"
                                value={nuevoContenido.descripcion}
                                onChange={(e) => this.setState({
                                  nuevoContenido: {...nuevoContenido, descripcion: e.target.value}
                                })}
                                placeholder="Descripción breve del contenido"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">URL de Video</label>
                              <input
                                type="url"
                                className="form-control"
                                value={nuevoContenido.url_video}
                                onChange={(e) => this.setState({
                                  nuevoContenido: {...nuevoContenido, url_video: e.target.value}
                                })}
                                placeholder="https://www.youtube.com/..."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Descripción Larga</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={nuevoContenido.descripcion_larga}
                            onChange={(e) => this.setState({
                              nuevoContenido: {...nuevoContenido, descripcion_larga: e.target.value}
                            })}
                            placeholder="Descripción detallada del contenido..."
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Archivo</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={this.handleArchivoChange}
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.mp4,.avi"
                          />
                          <small className="text-muted">
                            Formatos permitidos: PDF, Word, imágenes, video
                          </small>
                        </div>
                        <div className="d-flex justify-content-end">
                          {modalEditarContenido ? (
                            <>
                              <button 
                                type="button" 
                                className="btn btn-secondary me-2"
                                onClick={() => this.setState({ modalEditarContenido: false })}
                              >
                                Cancelar
                              </button>
                              <button 
                                type="button" 
                                className="btn btn-primary"
                                onClick={this.editarContenido}
                              >
                                <FontAwesomeIcon icon={faSave} className="me-2" />
                                Actualizar Contenido
                              </button>
                            </>
                          ) : (
                            <button 
                              type="button" 
                              className="btn btn-success"
                              onClick={this.crearContenido}
                            >
                              <FontAwesomeIcon icon={faPlus} className="me-2" />
                              Agregar Contenido
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Lista de contenidos existentes */}
                    <div className="card">
                      <div className="card-header bg-light">
                        <h6 className="mb-0">Contenidos Existentes</h6>
                      </div>
                      <div className="card-body">
                        {listaContenidos.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <th>Descripción</th>
                                  <th>Tipo</th>
                                  <th>Archivo</th>
                                  <th>Acciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                {listaContenidos.map((contenido) => (
                                  <tr key={contenido.id}>
                                    <td>
                                      <strong>{contenido.descripcion}</strong>
                                      {contenido.descripcion_larga && (
                                        <small className="text-muted d-block">{contenido.descripcion_larga}</small>
                                      )}
                                    </td>
                                    <td>
                                      {contenido.url_video ? (
                                        <span className="badge bg-danger">Video</span>
                                      ) : contenido.archivo ? (
                                        <span className="badge bg-primary">Archivo</span>
                                      ) : (
                                        <span className="badge bg-secondary">Texto</span>
                                      )}
                                    </td>
                                    <td>
                                      {contenido.archivo && (
                                        <small>{contenido.archivo}</small>
                                      )}
                                    </td>
                                    <td>
                                      <div className="btn-group btn-group-sm">
                                        <button
                                          className="btn btn-outline-primary"
                                          onClick={() => this.abrirModalEditarContenido(contenido)}
                                        >
                                          <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button
                                          className="btn btn-outline-danger"
                                          onClick={() => this.borrarContenido(contenido.id)}
                                        >
                                          <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="text-center text-muted py-4">
                            <FontAwesomeIcon icon={faBook} size="2x" className="mb-2" />
                            <p>No hay contenidos registrados para esta clase</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Estudiantes */}
          {estudiantesAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faUsers} className="me-2" />
                      Estudiantes del Curso: {cursoActual?.descripcion}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarEstudiantes}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="alert alert-info">
                      <FontAwesomeIcon icon={faInfo} className="me-2" />
                      Lista de estudiantes matriculados en este curso con su progreso actual.
                    </div>
                    
                    {listaEstudiantes.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-hover table-striped">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Estudiante</th>
                              <th>Correo</th>
                              <th>Cédula</th>
                              <th>Progreso</th>
                              <th>Materias Completadas</th>
                              <th>Estado</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listaEstudiantes.map((estudiante, index) => (
                              <tr key={estudiante.ide}>
                                <td>{index + 1}</td>
                                <td>
                                  <strong>{estudiante.nombre}</strong>
                                </td>
                                <td>
                                  <FontAwesomeIcon icon={faEnvelope} className="me-1 text-muted" />
                                  {estudiante.correo}
                                </td>
                                <td>
                                  <FontAwesomeIcon icon={faIdCard} className="me-1 text-muted" />
                                  {estudiante.cedula}
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="progress flex-grow-1 me-2" style={{height: '8px'}}>
                                      <div 
                                        className="progress-bar" 
                                        role="progressbar" 
                                        style={{width: `${estudiante.porcentaje_final}%`}}
                                        aria-valuenow={estudiante.porcentaje_final}
                                        aria-valuemin="0" 
                                        aria-valuemax="100"
                                      >
                                      </div>
                                    </div>
                                    <span className="badge bg-primary">
                                      {estudiante.porcentaje_final}%
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <span className="badge bg-secondary">
                                    {estudiante.materias_completadas} / {estudiante.total_materias}
                                  </span>
                                </td>
                                <td>
                                  {estudiante.porcentaje_final === 100 ? (
                                    <span className="badge bg-success">
                                      <FontAwesomeIcon icon={faCertificate} className="me-1" />
                                      Completado
                                    </span>
                                  ) : estudiante.porcentaje_final > 0 ? (
                                    <span className="badge bg-warning text-dark">
                                      En Progreso
                                    </span>
                                  ) : (
                                    <span className="badge bg-secondary">
                                      Sin Iniciar
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() => this.verEvaluacionesEstudiante(estudiante, cursoActual)}
                                    title="Ver evaluaciones realizadas"
                                  >
                                    <FontAwesomeIcon icon={faEye} className="me-1" />
                                    Ver Evaluaciones
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="text-center text-muted py-5">
                        <FontAwesomeIcon icon={faUsers} size="3x" className="mb-3" />
                        <h5>No hay estudiantes matriculados en este curso</h5>
                      </div>
                    )}
                    
                    {/* Resumen estadístico */}
                    {listaEstudiantes.length > 0 && (
                      <div className="row mt-4">
                        <div className="col-md-3">
                          <div className="card bg-primary text-white">
                            <div className="card-body text-center">
                              <h4>{listaEstudiantes.length}</h4>
                              <small>Total Estudiantes</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="card bg-success text-white">
                            <div className="card-body text-center">
                              <h4>
                                {listaEstudiantes.filter(e => e.porcentaje_final === 100).length}
                              </h4>
                              <small>Completados</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="card bg-warning text-dark">
                            <div className="card-body text-center">
                              <h4>
                                {listaEstudiantes.filter(e => e.porcentaje_final > 0 && e.porcentaje_final < 100).length}
                              </h4>
                              <small>En Progreso</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="card bg-secondary text-white">
                            <div className="card-body text-center">
                              <h4>
                                {listaEstudiantes.filter(e => e.porcentaje_final === 0).length}
                              </h4>
                              <small>Sin Iniciar</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={this.cerrarEstudiantes}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Resto del código permanece igual... */}
          {/* Modal de Certificado */}
          {certificadoAbierto && certificadoData && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-success text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faCertificate} className="me-2" />
                      Certificado de Finalización - {certificadoData.curso_nombre}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarCertificado}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="alert alert-info">
                      <FontAwesomeIcon icon={faInfo} className="me-2" />
                      Puedes imprimir este certificado usando el botón "Imprimir" o abrirlo en una nueva ventana para guardarlo como PDF.
                    </div>
                    
                    {/* Vista previa del certificado */}
                    <div className="certificate-preview border p-3 bg-light">
                      <div className="text-center">
                        <h2 className="text-success mb-4">
                          <FontAwesomeIcon icon={faCertificate} className="me-2" />
                          VISTA PREVIA DEL CERTIFICADO
                        </h2>
                        
                        <div className="mb-4">
                          <h4 className="text-primary">{certificadoData.empresa_nombre}</h4>
                          <p className="text-muted">NIT: {certificadoData.empresa_nit}</p>
                          {certificadoData.empresa_direccion && (
                            <p className="text-muted">{certificadoData.empresa_direccion}</p>
                          )}
                        </div>
                        
                        <div className="mb-4">
                          <p>Certifica que:</p>
                          <h3 className="text-dark border-bottom border-primary d-inline-block px-3">
                            {certificadoData.estudiante_nombre_completo}
                          </h3>
                          <p>Ha completado satisfactoriamente el curso:</p>
                          <h4 className="text-primary">{certificadoData.curso_nombre}</h4>
                        </div>
                        
                        <div className="mb-4">
                          <p>Con un promedio de aprobación de:</p>
                          <h2 className="text-success">{certificadoData.promedio_notas}%</h2>
                        </div>
                        
                        <div className="row mt-4">
                          <div className="col-md-6">
                            <p><strong>Fecha de finalización:</strong></p>
                            <p>{certificadoData.fecha_emision}</p>
                          </div>
                          <div className="col-md-6">
                            <p><strong>Código del certificado:</strong></p>
                            <p>{certificadoData.codigo_certificado}</p>
                          </div>
                        </div>
                        
                        <div className="mt-4 pt-4 border-top">
                          <p className="text-muted">
                            Materias completadas: {certificadoData.materias_completadas} de {certificadoData.total_materias}
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mt-4 text-center">
                      <button 
                        className="btn btn-primary btn-lg me-3"
                        onClick={this.descargarComoPDF}
                      >
                        <FontAwesomeIcon icon={faFilePdf} className="me-2" />
                        Abrir para Imprimir/Descargar PDF
                      </button>
                      
                      <button 
                        className="btn btn-success btn-lg"
                        onClick={() => {
                          this.descargarComoPDF();
                          setTimeout(() => {
                            window.print();
                          }, 1000);
                        }}
                      >
                        <FontAwesomeIcon icon={faPrint} className="me-2" />
                        Imprimir Directamente
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Video */}
          {videoAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-dark text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faPlay} className="me-2" />
                      Reproduciendo Video
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarVideo}
                    ></button>
                  </div>
                  <div className="modal-body p-0">
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="Video de la clase"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Documento */}
          {documentoAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-dark text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faFilePdf} className="me-2" />
                      {documentoNombre}
                    </h5>
                    <div>
                      <a 
                        href={documentoUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn btn-success btn-sm me-2"
                        download
                      >
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        Descargar
                      </a>
                      <button 
                        type="button" 
                        className="btn-close btn-close-white" 
                        onClick={this.cerrarDocumento}
                      ></button>
                    </div>
                  </div>
                  <div className="modal-body p-0">
                    <div style={{height: '80vh'}}>
                      <iframe
                        src={documentoUrl}
                        title={documentoNombre}
                        width="100%"
                        height="100%"
                        style={{border: 'none'}}
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Evaluación */}
          {evaluacionAbierta && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faTasks} className="me-2" />
                      Evaluación: {evaluacionActual?.titulo}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarEvaluacion}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="alert alert-info">
                      <FontAwesomeIcon icon={faInfo} className="me-2" />
                      Responde todas las preguntas según el tipo indicado. No podrás modificar tus respuestas después de enviar.
                    </div>
                    
                    {preguntasEvaluacion.map(preguntaData => 
                      this.renderPregunta(preguntaData)
                    )}
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={this.cerrarEvaluacion}
                    >
                      Cancelar
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-success" 
                      onClick={this.enviarEvaluacion}
                    >
                      <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                      Enviar Evaluación
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Vista principal de cursos */}
          {!cursoSeleccionado && !evaluacionAbierta && !videoAbierto && !documentoAbierto && !certificadoAbierto && !estudiantesAbierto && !modalCrearClase && !modalGestionarContenido && !evaluacionesEstudianteAbierto && (
            <div className="card">
              <div className="card-body">
                <h4>Mis Cursos Asignados</h4>
                <hr />
                <div className="row">
                  <div className="col-xl-3">
                    <input
                      style={{ textTransform: "uppercase" }}
                      type="text"
                      id="bnombre"
                      name="bnombre"
                      placeholder="Buscar por curso"
                      className="form-control form-control-sm"
                    />
                  </div>
                  <div className="col-xl-3">
                    <button 
                      id="bt" 
                      name="bt" 
                      className="btn btn-primary" 
                      onClick={() => this.MostrarTabla(1)}
                    >
                      &nbsp;&nbsp;Filtrar
                    </button>
                  </div>
                </div>
                
                <br />
                
                {/* Cards de cursos */}
                <div className="row">
                  {filteredList.map((curso, i) => (
                    <div key={curso.id} className="col-md-6 col-lg-6 mb-4">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-danger text-white d-flex justify-content-between align-items-center">
                          <h6 className="mb-0">
                            <FontAwesomeIcon icon={faBook} className="me-2" />
                            {curso.codigo}
                          </h6>
                          {/* Icono de certificado en el header */}
                          {curso.materias_completadas === curso.total_materias && curso.total_materias > 0 && (
                            <button
                              type="button"
                              className="btn btn-success btn-sm rounded-circle"
                              onClick={() => this.descargarCertificado(curso)}
                              title="Descargar certificado"
                              style={{ width: '30px', height: '30px', padding: 0 }}
                            >
                              <FontAwesomeIcon icon={faCertificate} />
                            </button>
                          )}
                        </div>
                        <div className="card-body">
                          <h4 className="card-title text-primary">{curso.descripcion}</h4>
                          
                          <div className="mb-2">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faUser} className="me-1" />
                              <strong>Docente:</strong> {curso.nombre}
                            </small>
                          </div>
                          
                          <div className="mb-2">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faCalendar} className="me-1" />
                              <strong>Inicio:</strong> {new Date(curso.fecha_inicio).toLocaleDateString()}
                            </small>
                          </div>
                          
                          <div className="mb-3">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faCalendar} className="me-1" />
                              <strong>Fin:</strong> {new Date(curso.fecha_final).toLocaleDateString()}
                            </small>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faFolder} className="me-1" />
                              <strong>Cantidad de Clases: </strong>  {curso.total_materias}
                            </small>
                          </div>
                          
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              {curso.promedio_notas > 0 ? (
                                <span className="badge bg-success">
                                  Promedio de Notas: {curso.promedio_notas} Puntos
                                </span>
                              ) : (
                                <span className="badge bg-warning text-dark">
                                  Sin iniciar
                                </span>
                              )}
                            </div>
                            
                            <div className="d-flex gap-2">
                              <button
                                type="button"
                                className="btn btn-info btn-sm"
                                onClick={() => this.VerContenidoCurso(curso.id)}
                              >
                                <FontAwesomeIcon icon={faInfo} /> Ver Contenido
                              </button>
                              <button
                                type="button"
                                className="btn btn-warning btn-sm"
                                onClick={() => this.verEstudiantes(curso)}
                              >
                                <FontAwesomeIcon icon={faUsers} /> Ver Estudiantes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Vista de contenido del curso */}
          {cursoSeleccionado && !evaluacionAbierta && !videoAbierto && !documentoAbierto && !certificadoAbierto && !estudiantesAbierto && !modalCrearClase && !modalGestionarContenido && !evaluacionesEstudianteAbierto && (
            <div className="card">
              <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0">
                  <FontAwesomeIcon icon={faBook} className="me-2" />
                  Contenido del Curso
                </h4>
                <div>
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => this.abrirModalCrearClase({ id: cursoSeleccionado })}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                    Nueva Clase
                  </button>
                  <button
                    className="btn btn-light btn-sm"
                    onClick={() => this.setState({ cursoSeleccionado: null, clasesCurso: [] })}
                  >
                    Volver a Cursos
                  </button>
                </div>
              </div>
              <div className="card-body">
                
                {/* Lista de clases */}
                <div className="row">
                  {clasesCurso.map((clase, index) => (
                    <div key={clase.materia.ccc} className="col-12 mb-4">
                      <div className="card shadow-sm">
                        <div 
                          className="card-header bg-light d-flex justify-content-between align-items-center cursor-pointer"
                          onClick={() => this.toggleClase(clase.materia.ccc)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div>
                            <h5 className="mb-0 text-primary">
                              <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                              {clase.materia.titulo}
                            </h5>
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faUser} className="me-1" />
                              Docente: {clase.materia.nombre}
                            </small>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="btn-group btn-group-sm me-2">
                              <button
                                className="btn btn-outline-primary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.abrirModalGestionarContenido(clase);
                                }}
                                title="Gestionar contenido"
                              >
                                <FontAwesomeIcon icon={faBook} />
                              </button>
                              <button
                                className="btn btn-outline-danger"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.borrarClase(clase.materia.ccc);
                                }}
                                title="Eliminar clase"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                            <span className="badge bg-secondary me-2">
                              {clase.total_contenidos} contenidos
                            </span>
                            <span className="badge bg-info me-2">
                              {clase.evaluaciones.length} evaluaciones
                            </span>
                            <FontAwesomeIcon 
                              icon={clasesAbiertas[clase.materia.ccc] ? faChevronUp : faChevronDown} 
                            />
                          </div>
                        </div>
                        
                        {/* Contenido desplegable */}
                        {clasesAbiertas[clase.materia.ccc] && (
                          <div className="card-body">
                            
                            {/* Contenidos */}
                            {clase.contenidos.length > 0 && (
                              <div className="mb-4">
                                <h6 className="text-primary mb-3">
                                  <FontAwesomeIcon icon={faBook} className="me-2" />
                                  Material de Estudio
                                </h6>
                                <div className="row">
                                  {clase.contenidos.map((contenido) => (
                                    <div key={contenido.id} className="col-md-12 mb-3">
                                      <div className="card border">
                                        <div className="card-body">
                                          <div className="d-flex align-items-start">
                                            <FontAwesomeIcon 
                                              icon={this.getIconoPorTipo(contenido.archivo)} 
                                              className="text-primary mt-1 me-3"
                                              size="lg"
                                            />
                                            <div className="flex-grow-1">
                                              <h6 className="card-title mb-1">{contenido.descripcion}</h6>
                                              <p className="card-title mb-1">{contenido.descripcion_larga}</p>
                                              {contenido.archivo && (
                                                <div className="mb-2">
                                                  <button
                                                    className="btn btn-outline-primary btn-sm me-2"
                                                    onClick={() => this.abrirDocumento(
                                                      contenido.archivo, 
                                                      contenido.descripcion
                                                    )}
                                                  >
                                                    <FontAwesomeIcon icon={faFile} className="me-1" />
                                                    Ver Documento
                                                  </button>
                                                  <a 
                                                    href={`http://127.0.0.1:8000/storage/${contenido.archivo}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-success btn-sm"
                                                    download
                                                  >
                                                    <FontAwesomeIcon icon={faDownload} className="me-1" />
                                                    Descargar
                                                  </a>
                                                </div>
                                              )}
                                              {contenido.url_video && (
                                                <div>
                                                  <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => this.abrirVideo(contenido.url_video)}
                                                  >
                                                    <FontAwesomeIcon icon={faPlay} className="me-1" />
                                                    Ver Video
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                            
                            {/* Evaluaciones */}
                            {clase.evaluaciones.length > 0 && (
                              <div>
                                <h6 className="text-primary mb-3">
                                  <FontAwesomeIcon icon={faTasks} className="me-2" />
                                  Evaluaciones
                                </h6>
                                <div className="row">
                                  {clase.evaluaciones.map((evaluacion) => (
                                    <div key={evaluacion.id} className="col-md-6 mb-3">
                                      <div className="card border-warning">
                                        <div className="card-body">
                                          <div className="d-flex align-items-start">
                                            <FontAwesomeIcon 
                                              icon={faTasks} 
                                              className="text-warning mt-1 me-3"
                                              size="lg"
                                            />
                                            <div className="flex-grow-1">
                                              <h6 className="card-title mb-1">{evaluacion.descripcion}</h6>
                                              <div className="d-flex justify-content-between align-items-center">
                                                <span className="badge bg-warning text-dark">
                                                  Evaluación
                                                </span>
                                                {evaluacion.nota==null?
                                                <button
                                                  className="btn btn-primary btn-sm"
                                                  onClick={() => this.VerEvaluacion(
                                                    evaluacion.evaluacion, 
                                                    clase.materia.titulo,
                                                    clase.materia.ccc
                                                  )}
                                                >
                                                  <FontAwesomeIcon icon={faTasks} className="me-1" />
                                                  Realizar Evaluación
                                                </button>:evaluacion.nota+' Puntos'} 
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                            
                            {clase.contenidos.length === 0 && clase.evaluaciones.length === 0 && (
                              <div className="text-center text-muted py-4">
                                <FontAwesomeIcon icon={faBook} size="2x" className="mb-2" />
                                <p>No hay contenido disponible para esta clase</p>
                                <button
                                  className="btn btn-primary btn-sm mt-2"
                                  onClick={() => this.abrirModalGestionarContenido(clase)}
                                >
                                  <FontAwesomeIcon icon={faPlus} className="me-1" />
                                  Agregar Contenido
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                
                {clasesCurso.length === 0 && (
                  <div className="text-center text-muted py-5">
                    <FontAwesomeIcon icon={faBook} size="3x" className="mb-3" />
                    <h5>No hay clases disponibles para este curso</h5>
                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => this.abrirModalCrearClase({ id: cursoSeleccionado })}
                    >
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      Crear Primera Clase
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Docente